module.exports = __webpack_public_path__ + "img/natural.b498d5d8.png";